import { cn } from "@/lib/utils";
import {
    CheckCircle,
    DollarSign,
    FileText,
    RotateCcw,
    Undo2,
    XCircle,
} from "lucide-react";

const STATUS_META: Record<string, { icon: any; className: string }> = {
    DRAFT: {
        icon: FileText,
        className: "bg-slate-50 text-slate-600 border border-slate-200",
    },
    CONFIRMED: {
        icon: CheckCircle,
        className: "bg-blue-50 text-blue-600 border border-blue-100",
    },
    PAID: {
        icon: DollarSign,
        className: "bg-emerald-50 text-emerald-600 border border-emerald-100",
    },
    CANCELLED: {
        icon: XCircle,
        className: "bg-red-50 text-red-600 border border-red-100",
    },
    REFUNDED: {
        icon: RotateCcw,
        className: "bg-purple-50 text-purple-600 border border-purple-100",
    },
    RETURNED: {
        icon: Undo2,
        className: "bg-orange-50 text-orange-600 border border-orange-100",
    },
};

export function OrderStatusBadge({ status, cod }: { status: string, cod?: boolean }) {
    const meta = STATUS_META[status] ?? STATUS_META["DRAFT"];
    const Icon = meta.icon;

    return (
        <span className="inline-flex items-center gap-1.5">
            <span
                className={cn(
                    "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full font-medium",
                    "transition-colors select-none",
                    meta.className
                )}
            >
                <Icon className="h-3.5 w-3.5" />
                {status.toLowerCase()}
            </span>
        </span>
    );
}
